export default {
  loading_menu: 'Loading menu...',
};
